import { GtmhubController } from "@gtmhub/core";
import { localize } from "@gtmhub/localization";
import { IComponentOptions } from "angular";
import { ITask } from "../models/models";

enum GtmhubTaskStatus {
  toDo = "todo",
  inProgress = "inprogress",
  done = "done",
}
const toDoKey = "to_do";
const inProgressKey = "in_progress";
const doneKey = "done";
const gtmhubStatusKeys = {
  [GtmhubTaskStatus.toDo]: toDoKey,
  [GtmhubTaskStatus.inProgress]: inProgressKey,
  [GtmhubTaskStatus.done]: doneKey,
};
const jiraStatusKeys = {
  "to do": toDoKey,
  "in progress": inProgressKey,
  done: doneKey,
};

interface ITaskStatusBindings {
  task?: ITask;
  tabIndexStart?: number;
  readonly?: boolean;
  disabled?: boolean;
  onChange?(arg: { value: GtmhubTaskStatus }): void;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface TaskStatusCtrl extends ITaskStatusBindings {}
class TaskStatusCtrl extends GtmhubController {
  statuses = GtmhubTaskStatus;

  buttonText(): string {
    if (this.task) {
      if (this.task.externalSystem === "jira") {
        const status = this.task.status.toLocaleLowerCase();
        return localize(jiraStatusKeys[status]) || this.task.status;
      } else if (!this.task.externalSystem) {
        return localize(gtmhubStatusKeys[this.task.status]) || "...";
      }
    }
    return "";
  }

  statusChanged(value: GtmhubTaskStatus): void {
    if (this.onChange) {
      this.onChange({ value });
    }
  }

  tabIndex(offset: number): number {
    if (typeof this.tabIndexStart !== "undefined") {
      return this.tabIndexStart + offset;
    } else {
      return 0;
    }
  }

  toggleButtonClass(): string {
    if (this.task) {
      return this.task.status.toLowerCase().replace(" ", "");
    } else {
      return "";
    }
  }
}

export const TaskStatusComponent: IComponentOptions = {
  templateUrl: require("./task-status.jade"),
  controller: TaskStatusCtrl,
  bindings: {
    task: "<",
    tabIndexStart: "<?",
    readonly: "<?",
    disabled: "<?",
    onChange: "&",
  },
};
